import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <h3>Remotix: Universal TV Remote</h3>
            <p>Control your TV, AC & more from your smartphone using WiFi and IR Blaster technology.</p>
          </div>

          <div className="footer-links-group">
            <h4>Quick Links</h4>
            <Link to="/">Home</Link>
            <Link to="/support">Support</Link>
            <Link to="/terms">Terms & Conditions</Link>
            <Link to="/privacy">Privacy Policy</Link>
          </div>

          <div className="footer-links-group">
            <h4>Features</h4>
            <span>TV Remote Control</span>
            <span>AC Remote Control</span>
            <span>Screen Mirroring</span>
            <span>IPTV Player</span>
          </div>

          <div className="footer-links-group">
            <h4>Get the App</h4>
            <a href="https://play.google.com/store/apps/details?id=com.remote.master.universal" target="_blank" rel="noopener noreferrer">
              Android - Google Play
            </a>
            <a href="https://apps.apple.com/app/id6760695054" target="_blank" rel="noopener noreferrer">
              iOS - App Store
            </a>
            <a href="mailto:support@universaltvremote.app">
              Contact Us
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Remotix: Universal TV Remote. All rights reserved.</p>
          <div className="footer-bottom-links">
            <Link to="/terms">Terms</Link>
            <Link to="/privacy">Privacy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
